import { Combobox, FormControl, FormField, FormItem, FormLabel, FormMessage, RadioGroup, RadioGroupItem, Text } from "@sentricmusic/ui";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import type { GigClaimFormValues } from "../utils/gigsClaimSchema";

type LineUpSectionProps = {
  variant: "combobox" | "radio";
};

function LineUpSection({ variant }: LineUpSectionProps) {
  const { t } = useTranslation(["gigs"]);
  const { control } = useFormContext<GigClaimFormValues>();

  if (variant === "radio") {
    return (
      <div>
        <Text as="subtitle">{t("gigs:lineup-header", "Line-up")}</Text>
        <div className="flex flex-col gap-2">
          <FormField
            control={control}
            name="lineUpPosition"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t("gigs:position-in-lineup", "Position in lineup")}</FormLabel>
                <FormControl>
                  <RadioGroup
                    value={field.value ?? ""}
                    onValueChange={field.onChange}
                    className="flex flex-row gap-4"
                  >
                    <div className="flex items-center gap-2">
                      <RadioGroupItem id="lineUpPosition-headline" value="headline" />
                      <label htmlFor="lineUpPosition-headline" className="text-sm font-sentric-alt cursor-pointer">
                        {t("gigs:headline-artist", "Headline artist")}
                      </label>
                    </div>
                    <div className="flex items-center gap-2">
                      <RadioGroupItem id="lineUpPosition-support" value="support" />
                      <label htmlFor="lineUpPosition-support" className="text-sm font-sentric-alt cursor-pointer">
                        {t("gigs:support-artist", "Support artist")}
                      </label>
                    </div>
                  </RadioGroup>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>
      </div>
    );
  }

  return (
    <div>
      <Text as="subtitle">{t("gigs:lineup-header", "Line-up")}</Text>
      <div className="flex flex-col gap-2">
        <FormField
          control={control}
          name="lineUpPosition"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("gigs:lineup-position-placeholder", "Lineup Position")}</FormLabel>
              <FormControl>
                <Combobox
                  placeholder={t("gigs:lineup-position-placeholder", "Lineup Position") ?? "Lineup Position"}
                  value={field.value ?? ""}
                  onValueChange={field.onChange}
                  data={[
                    { label: t("gigs:headline-artist", "Headline artist"), value: "Headline Artist" },
                    { label: t("gigs:support-artist", "Support artist"), value: "Support Artist" },
                    { label: t("gigs:festival-performance", "Festival Performance"), value: "Festival Performance" },
                  ]}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  );
}

export default LineUpSection;
